module.exports = __webpack_public_path__ + "static/media/WhyKaiZen.d5f8c869.jpg";